import * as React from 'react';
import FullComposeForm from './FullComposeForm';

export default function ProjectionCalendarCompose() {
    return <FullComposeForm />;
}
